/**
 * @fileoverview PATCH handler for the "/internal_user_groups/test_user" endpoint
 */
import fetch from "@lib/fetch";

import type { AppSettingsInternalUserGroupsInternalUserGroupIdV2TestUsersResultItem } from "../appSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsTestUserCacheKeys } from "./constants";
import type { PatchAppSettingsInternalUserGroupsTestUserProps } from "./types";

export const patchAppSettingsInternalUserGroupsTestUser = reactQueryMutationAdapter(
  appSettingsInternalUserGroupsTestUserCacheKeys,
  ({
    id,
    name,
  }: PatchAppSettingsInternalUserGroupsTestUserProps): Promise<AppSettingsInternalUserGroupsInternalUserGroupIdV2TestUsersResultItem> => {
    return fetch("/internal_user_groups/test_user", "PATCH", {
      test_user_id: id,
      test_user_name: name,
    });
  }
);
